import { TTaskFlowInstance } from './task-flow-engine';

export const checkIsNewSession = (
  previousTaskFlowInstance: TTaskFlowInstance | null,
  nextTaskFlowInstance: TTaskFlowInstance,
) =>
  !previousTaskFlowInstance ||
  previousTaskFlowInstance.currentSession.id !== nextTaskFlowInstance.currentSession.id;
